export enum AncillaryQueryKey {
    AncillaryDetails = "ancillary-details"
}
